import { motion } from "framer-motion";

const partners = [
  { name: "TechVentures", id: 1 },
  { name: "CapitalOne Partners", id: 2 },
  { name: "Nexus Investments", id: 3 },
  { name: "FutureScale VC", id: 4 },
  { name: "Horizon Capital", id: 5 },
  { name: "Atlas Holdings", id: 6 },
  { name: "Pinnacle Growth", id: 7 },
  { name: "Quantum Fund", id: 8 },
];

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="py-16 border-y border-white/5 bg-[#050505] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs font-mono tracking-wider uppercase text-slate-500 text-center"
        >
          Trusted by Leading Investors & Startups
        </motion.p>
      </div>

      {/* Marquee Container */}
      <div className="relative">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />

        {/* Scrolling Content */}
        <div className="flex animate-marquee">
          {/* First Set */}
          {[...partners, ...partners].map((partner, index) => (
            <div
              key={`${partner.id}-${index}`}
              className="flex items-center justify-center min-w-[200px] px-8"
            >
              <span className="text-xl font-semibold text-white/30 hover:text-white/60 transition-colors whitespace-nowrap">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
